import { AppState } from '../model';

export const getLocale = (state: AppState): string => state.locale.locale;

export const getMessages = (state: AppState): {} => state.locale.messages;